<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Сайт для клиентов</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Клиент может попасть на&nbsp;сайт из&nbsp;телеграм-бота или по&nbsp;прямой ссылке.</p>

            <p>
              Пока интеграция доступна только с&nbsp;Telegram. В&nbsp;разработке находится подключение к&nbsp;Instagram,
              Snapchat и&nbsp;Facebook Messenger.
            </p>

            <p>При заходе через бот, аккаунт пользователя создаётся автоматически.</p>

            <p>При заходе через сайт есть разные варианты&nbsp;&mdash; социальные сети или электронная почта.</p>

            <p>
              Важно! Чтобы заходить через один и&nbsp;тот&nbsp;же аккаунт в&nbsp;боте и&nbsp;по&nbsp;прямой ссылке,
              необходимо в&nbsp;личных данных пользователя этого аккаунта авторизовать в&nbsp;Telegram и&nbsp;заполнить
              почту. В&nbsp;зависимости от&nbsp;того, что было первичнее (зашли через бот или по&nbsp;почте через сайт)
              останется один вариант, который нужно будет заполнить.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="struktura-i-funktsional"
            class="typography__headline2"
          >
            Структура и функционал
          </FaqArticlesBlockHeading>

          <div class="block">
            <h3 class="typography__headline4">О нас</h3>

            <div class="block-small">
              <p>Разделе с&nbsp;описанием и&nbsp;контактами проекта.</p>

              <p>В&nbsp;&laquo;Филиалы&raquo; список филиалов с&nbsp;картой, контактами и&nbsp;графиком работы.</p>

              <p>В&nbsp;&laquo;Сотрудники&raquo; список сотрудников с&nbsp;перечислением рабочих филиалов.</p>

              <p>
                Самый нижний подраздел с&nbsp;информационными страницами и&nbsp;возможностью их&nbsp;посмотреть.
                Он&nbsp;будет называться так, как его назвали в&nbsp;настройках сайта.
              </p>
            </div>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block">
            <h3 class="typography__headline4">Личный кабинет</h3>

            <div class="block-small">
              <p>В&nbsp;&laquo;Заказы и&nbsp;записи&raquo; все оформления на&nbsp;сайте с&nbsp;их&nbsp;деталями.</p>

              <p>В&nbsp;&laquo;Адреса доставки&raquo;. все адреса клиента для доставки заказов с&nbsp;товарами.</p>

              <p>
                В&nbsp;&laquo;Личные данные&raquo; информация клиента, нужная для оформления заказов и&nbsp;записей
                и&nbsp;авторизации на&nbsp;сайте.
              </p>

              <p>В&nbsp;&laquo;Настройки&raquo; безвозвратное удаление аккаунта клиента.</p>
            </div>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block">
            <h3 class="typography__headline4">Онлайн запись</h3>

            <div class="block-small">
              <p>
                Раздел с&nbsp;возможностью записаться на&nbsp;услугу в&nbsp;определенный филиал и&nbsp;день
                к&nbsp;нужному мастеру.
              </p>

              <p>Название раздела и&nbsp;подпись могут быть отредактированы в&nbsp;настройках сайта.</p>
            </div>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block">
            <h3 class="typography__headline4">Групповая запись</h3>

            <div class="block-small">
              <p>Раздел с&nbsp;возможностью записаться на&nbsp;групповую услугу из&nbsp;предложенного списка.</p>

              <p>Название раздела и&nbsp;подпись могут быть отредактированы в&nbsp;настройках сайта.</p>
            </div>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block">
            <h3 class="typography__headline4">Наши услуги</h3>

            <div class="block-small">
              <p>
                Раздел со&nbsp;всеми услугами проекта. Помимо услуг для онлайн записи, можно выбрать услугу для заявки.
              </p>

              <p>Название раздела и&nbsp;подпись могут быть отредактированы в&nbsp;настройках сайта.</p>
            </div>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block">
            <h3 class="typography__headline4">Наши товары</h3>

            <div class="block-small">
              <p>Раздел с&nbsp;возможностью оформить заказ с&nbsp;товарами из&nbsp;каталога.</p>

              <p>Название раздела и&nbsp;подпись могут быть отредактированы в&nbsp;настройках сайта.</p>
            </div>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/sayt-dlya-klientov-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как устроен сайт для клиента разобрались. Самое время перейти к
            <BaseLink
              class="ui-link-secondary"
              to="/faq/categories/klienty"
              >изучению и настройке клиентов </BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сайт",
    url: "/faq/categories/sayt",
  },
  {
    name: "Сайт для клиентов",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Структура&nbsp;и&nbsp;функционал",
    url: "struktura-i-funktsional",
  },
];

const relatedArticles = [
  {
    name: "Конструктор сайта",
    slug: "konstruktor-sayta",
  },
  {
    name: "Информационные страницы",
    slug: "informatsionnyye-stranitsy",
  },
  {
    name: "Политики конфиденциальности",
    slug: "politiki-konfidencialnosti",
  },
];

useSeoMeta({
  title: "Сайт для клиентов",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
